import { z } from 'zod'
import { dateOrIsoString } from '~/prix/types/date'
import { latitude, longitude } from '~/prix/types/presets/geo'
import sql from '~/prix/utils/sql'
import { numericValue } from '../heavyMachinery/heavyMachineryObject'

export const communityGardenObject = z.object({
  id: z.string().uuid(),
  title: z.string(),
  address: z.string().nullish(),
  latitude: latitude().nullish(),
  longitude: longitude().nullish(),
  observation: z.string().nullish(),
  area: numericValue.nullish(),
  bedsCount: z.number().int().nullish(),
  clientId: z.number().int(),
  createdAt: dateOrIsoString().nullish(),
  updatedAt: dateOrIsoString().nullish(),
  deletedAt: dateOrIsoString().nullish(),
})

export type CommunityGardenType = z.infer<typeof communityGardenObject>

export const propertyMap = {
  id: sql`community_garden.id`,
  title: sql`community_garden.title`,
  address: sql`community_garden.address`,
  latitude: sql`community_garden.latitude`,
  longitude: sql`community_garden.longitude`,
  observation: sql`community_garden.observation`,
  area: sql`community_garden.area`,
  bedsCount: sql`community_garden.beds_count`,
  clientId: sql`community_garden.client_id`,
  createdAt: sql`community_garden.created_at`,
  updatedAt: sql`community_garden.updated_at`,
  deletedAt: sql`community_garden.deleted_at`,
}
